export interface MenuItem {
  id: number;
  name: string;
  route: string;
  icon: string;
  role: string;
  status: string;
  parent_id: number | string | null;
  order: number | string;
  audience?: string;
  environment: string;
  // true = not ready for prod; backend then serves `legacy_route` in `route`.
  feature_flag?: boolean;
  legacy_route?: string | null;
  // Defaults to 'top'; nested items always share their parent's position.
  position?: 'top' | 'bottom';
  parent_title?: string | null;
  parent?: MenuItem; // nested parent item
  children?: MenuItem[]; // optional if used for nested menu tree
}

// True when the backend swapped `route` for the legacy link. If the flag is on
// but `legacy_route` is empty, `route` stays the normal link.
export function isLegacyMenuItem(item: Pick<MenuItem, 'feature_flag' | 'legacy_route'>): boolean {
  return !!item.feature_flag && !!item.legacy_route?.trim();
}

// Menu tree split by `position`; each group is sorted by `order`.
export interface SidebarMenu {
  top: MenuItem[];
  bottom: MenuItem[];
}
